import React from "react";
import {
    Image,
    Carousel
} from "antd";
import Slider from "react-slick";
import fileUtils from "../../../utils/file-utils";
import { galleryType } from '../../../constants/app-constants';
// import "antd/dist/antd.css";
// import "./index.css";

const Slide = (props) => {

    const { photoList } = props;

    const renderSlideList = () => {
        if (!photoList) {
            return null;
        }

        const imageList = []
        photoList.forEach(element => {
            if (element.fileName != null) {
                imageList.push(element)
            }
        });

        return imageList.map((items) => {
            return (<div>
                <Image width={300} src={fileUtils.getGalleryRenderUrl(
                    galleryType.PHOTO,
                    items.path,
                    items.fileName
                )}
                    preview={false}
                />
            </div>
            )
        });

    };

    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
    };
    return (
        <div>
            {/* <h2>Auto Play & Pause with buttons</h2> */}
            <Slider   {...settings}>
                {renderSlideList()}
            </Slider>
        </div>
    );

    // const Arrow = ({ type, onClick }) => {
    //     if (type === "left") {
    //         return <LeftOutlined onClick={onClick}/>
    //     }else if (type === "right"){
    //         return <RightOutlined  onClick={onClick} />

    //     }
    // };

    // const renderSlideList = () => {
    //     if (!photoList) {
    //         return null;
    //     }

    //     const imageList = []
    //     photoList.forEach(element => {
    //         if (element.fileName != null) {
    //             imageList.push(element)
    //         }
    //     });

    //     return imageList.map((items) => {
    //         let bodyImage;
    //         bodyImage = <Image width={300} src={fileUtils.getGalleryRenderUrl(
    //             galleryType.PHOTO,
    //             items.path,
    //             items.fileName
    //         )}
    //             preview={false}
    //         />
    //         return (bodyImage)
    //     });

    // };

    // return (
    //     <Carousel autoplay arrows
    //         prevArrow={<Arrow type="left" onClick={slickGoTo()}/>}
    //         nextArrow={<Arrow type="right" onClick={slickNext()}/>} >
    //         {renderSlideList()}
    //     </Carousel>

    // );
}

export default Slide;
